module.exports = __webpack_public_path__ + "static/img/gate_h.b8b41eda.png";